import {DefaultPageProps} from "@models/DefaultProps.ts";
import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    ToggleButton,
    ToggleButtonGroup
} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import React, {useEffect, useState} from "react";
import {GastosContasContabeisFilters} from "@models/contaContabil/ContaContabilFilterDto.tsx";
import {IObjectCounter, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {GetGastosContasContabeis} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {ToMoney} from "@shared/MathHelp";
import {BarChart} from "@mui/x-charts";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {DefaultPagination} from "@shared/specialComponents/DefaultPagination.tsx";
import {useGeneral} from "@contexts/GeneralContext.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface ContaContabilGastosPageProps extends DefaultPageProps {
    hideGoToPageButton?: never
    contaContabilId?: number[]
}

type exibicao = 'Tabela' | 'Grafico'

export const ContaContabilGastosPage: React.FC<ContaContabilGastosPageProps> = (props) => {
    const {Get} = useApi()
    const {screenSizeLevel} = useGeneral()

    const [exibicao, setExibicao] = useState<exibicao>('Grafico')

    const [filters, setFilters] = useState<GastosContasContabeisFilters>({
        idContaContabil: props.contaContabilId || [],
        filtrarPor: 'recurso'
    });

    // const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10});
    const [gastos, setGastos] = useState<IObjectCounter[]>([]);

    useEffect(() => {
        if (pagination.page == 0) {
            setPagination({...pagination, page: 1})
            return
        }
        setGastos([])

        // setLoading(true)
        Get(GetGastosContasContabeis(filters, pagination)).then(x => {
            if (x.status == 'Success') {
                setGastos(x.items)
                setPagination(pagination)
            }
        }).finally(() => {
            // setLoading(false)
        })

    }, [pagination.page]);


    return (
        <DefaultContainer titulo={props.hideHeader ? '' : 'Gastos das contas contabeis'} component={Paper}>
            <Grid container rowSpacing={1.5}>
                <Grid size={screenSizeLevel >= 6 ? 6 : undefined}>
                    <DatePicker value={filters.dataInicio} label={'Data inicial'} onChange={(e) => {
                        setFilters({
                            ...filters,
                            dataInicio: dayjs(e)
                        })
                    }}
                                slotProps={{
                                    actionBar: {actions: ['clear', 'today']},
                                    textField: {fullWidth: true}
                                }}/>
                </Grid>
                <Grid size={screenSizeLevel >= 6 ? 6 : undefined}>
                    <DatePicker value={filters.dataInicio} label={'Data final'} onChange={(e) => {
                        setFilters({
                            ...filters,
                            dataFim: dayjs(e)
                        })
                    }}
                                slotProps={{
                                    actionBar: {actions: ['clear', 'today']},
                                    textField: {fullWidth: true}
                                }}
                    />
                </Grid>
                <Grid size={screenSizeLevel >= 6 ? 12 : 'grow'}>
                    <FormControl fullWidth>
                        <InputLabel>Tipo de metrica</InputLabel>
                        <Select label={'Tipo de metrica'} value={filters.filtrarPor} onChange={(e) => {
                            setFilters({
                                ...filters,
                                filtrarPor: e.target.value as GastosContasContabeisFilters['filtrarPor']
                            })
                        }}>
                            <MenuItem value={'recurso'}>Recurso</MenuItem>
                            <MenuItem value={'data'}>Data</MenuItem>
                            <MenuItem value={'mes'}>Mês</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={screenSizeLevel >= 6 ? 12 : 'grow'}>
                    <Button fullWidth sx={{height: '100%', maxHeight: '100%'}} variant={'outlined'} onClick={() => {
                        setPagination({...pagination, page: 0})
                    }}
                    >Filtrar</Button>
                </Grid>
            </Grid>
            <Grid size={12} py={1}>
                <ToggleButtonGroup value={exibicao} size={'small'}>
                    <ToggleButton value={'Grafico'} onClick={() => {
                        setExibicao('Grafico')
                    }}>Grafico</ToggleButton>
                    <ToggleButton value={'Tabela'} onClick={() => {
                        setExibicao('Tabela')
                    }}>Tabela</ToggleButton>
                </ToggleButtonGroup>
            </Grid>

            {exibicao == 'Tabela' && <Grid container>
                <Grid size={12} mb={1}>
                    <DefaultPagination pagination={pagination} setPagination={setPagination} posicao={'top'}/>
                </Grid>
                {gastos.map((gasto) => (
                    <Grid key={gasto.id} size={12}>
                        <Grid container justifyContent={"space-between"} sx={{height: '100%', maxHeight: '100%'}}>
                            <Grid container alignContent={'center'} spacing={1}>
                                <Grid>
                                    {gasto.name}
                                </Grid>
                                <Grid>
                                    {gasto.count}
                                </Grid>
                                <Grid>
                                    {ToMoney(gasto.value)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
                <Grid size={12} pt={1}>
                    <DefaultPagination pagination={pagination} setPagination={setPagination} posicao={'bottom'}/>
                </Grid>
            </Grid>}
            {exibicao == 'Grafico' && <Grid container>
                <BarChart height={300}
                          barLabel={(i) => ToMoney(i.value)}
                          xAxis={[{data: gastos.map(x => x.name)}]}
                          series={[{data: gastos.map(x => Math.abs(x.value ?? 0))}]}

                />
            </Grid>}
        </DefaultContainer>
    )
}